import { Module } from '@nestjs/common';
import { FgStockTransferController } from './fg-stock-transfer.controller';
import { FgStockTransferService } from './fg-stock-transfer.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { fgStockTransfer } from './fg-stock-transfer.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
@Module({
  imports: [
    TypeOrmModule.forFeature([fgStockTransfer]),
  ],
  exports: [TypeOrmModule],
  controllers: [FgStockTransferController],
  providers: [FgStockTransferService,ApplicationExceptionHandler,WhatsAppNotificationService,WhatsappBroadCastService]
  
})
export class FgStockTransferModule {}
